"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Grid_1 = __importDefault(require("../Align/Grid"));
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const Button_1 = __importDefault(require("../Util/Button"));
const Checkbox_1 = __importDefault(require("./Checkbox"));
const useToggleableChange_1 = require("../../hooks/useToggleableChange");
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const useInputForm_1 = require("../../hooks/useInputForm");
const InlineSelectInput = (props) => {
    var _a;
    let optionMap = {};
    if (Array.isArray(props.options)) {
        props.options.forEach((propValue) => {
            optionMap[propValue] = propValue;
        });
    }
    else if (typeof optionMap === 'object') {
        optionMap = props.options;
    }
    const value = useInputForm_1.useInputValue(props);
    const onChange = useInputForm_1.useInputFormChange(props);
    const toggleableProps = useToggleableChange_1.useToggleableChange(onChange, props.onClick, props.disabled);
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error },
        react_1.default.createElement(InputLabel_1.default, { className: "retracted" }),
        react_1.default.createElement(Grid_1.default, { columns: (_a = props.columns) !== null && _a !== void 0 ? _a : 2 },
            Object.keys(optionMap).map((optionValue) => {
                const isChecked = Array.isArray(value) ? value.includes(optionValue) : optionValue === value;
                const label = optionMap[optionValue];
                return (react_1.default.createElement(Button_1.default, Object.assign({}, toggleableProps, { key: label, className: "j-inline-select-input-option" }),
                    react_1.default.createElement(Checkbox_1.default, { key: optionValue, checkedValue: optionValue, 
                        /* The unchecked value is still the value as we need
                        to know it when we uncheck in an array.
                        */
                        uncheckedValue: optionValue, name: props.name, checked: isChecked }),
                    react_1.default.createElement("span", null, label)));
            }),
            props.children),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-inline-select-input', InlineSelectInput);
